export enum RequestTitlesEnum {
  Information = 'Informazioni',
  Advice = 'Consulenza',
  DrugsOrExaminations = 'Farmaci o esami',
}
